import {Injectable} from '@angular/core';
import {Store} from "@ngxs/store";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {RequestService} from "./request.service";
import {CarteraInterface} from "../models/cartera.interface";
import {InstrumentoInterface} from "../models/instrumento.interface";
import {OperacionInterface} from "../models/operacion.interface";
import {OperacionSimboloInterface} from "../models/operacion-simbolo.interface";
import {OptionsInterface} from "../models/options.interface";
import {ActivosInterface} from "../models/activos.interface";
import {CarteraAction} from "../actions/cartera-action";
import FetchPagination = CarteraAction.FetchPaginationCartera;
import { AppState } from '../states/app.state';
import { AppHelper } from '../helpers/app.helper';

@Injectable({
  providedIn: 'root'
})
export class CarteraService {

  locale: string = 'es-AR';

  constructor(private store: Store, private requestService: RequestService, private http: HttpClient) {

      this.store.select(AppState.profile).subscribe((p: any) => {

          this.locale = p?.locale || 'es-ES';
      });

  }

  async obtenerSimbolos(id, hideLoading = false) {

      try {

          const columns = this.store.selectSnapshot(state => state.carteraData).operacionColumnas;

         // const dataSource = { itemsPerPage:0, data: [], page: 1, recordsFiltered: 0, recordsTotal: 0 };

        // const pagination = { itemsPerPage:50, data: [], page: 1, recordsFiltered: 0, recordsTotal: 0 };

          const pagination = this.store.selectSnapshot(state => state.paginationData).pagination;

          let resp = await  this.requestService.get('operacion_simbolo_index',{ hideLoading, params: { }, query: `cartera.id=${id}&pageable=1&page=${pagination.page}&pagination=${pagination.itemsPerPage}&exists[deletedAt]=0` });

          let data = (resp.data).map((os: any) => {


                  AppHelper.FormatFromColumn(os, columns, this.locale);
                  os.lotes = AppHelper.FormatNumber(os.lotes, this.locale, 0, 'decimal');
                  os.operaciones.forEach(o => {

                      o.esCompra = o.esCompra ? 1 : 0;
                      o.inVolumen = o.volumen;
                      o.volumen = AppHelper.FormatNumber(o.volumen, this.locale, 0, 'decimal');
                      AppHelper.FormatFromColumn(o, columns, this.locale);
                  });
                  return os;

            })

          resp.data = [... data];

         // console.log('data simbolos: ', {...data});

          // dataSource.data = [...data];
          // dataSource.itemsPerPage = resp.itemsPerPage;
          // dataSource.page = resp.page;
          // dataSource.recordsFiltered = resp.recordsFiltered
          // dataSource.recordsTotal = resp.recordsTotal;


          //this.store.dispatch(new FetchPagination(dataSource));

          return resp;
         //console.log(array);

          // return ( await  this.requestService.get('operacion_simbolo_index',
          //     { hideLoading, params: { }, query: `cartera.id=${id}&pageable=0&exists[deletedAt]=0` }) || [])
              // .map((os: any) => {

              //   console.log('Simbolos response: ', os);

              //     AppHelper.FormatFromColumn(os, columns, this.locale);
              //     os.lotes = AppHelper.FormatNumber(os.lotes, this.locale, 0, 'decimal');
              //     os.operaciones.forEach(o => {

              //         o.esCompra = o.esCompra ? 1 : 0;
              //         o.inVolumen = o.volumen;
              //         o.volumen = AppHelper.FormatNumber(o.volumen, this.locale, 0, 'decimal');
              //         AppHelper.FormatFromColumn(o, columns, this.locale);
              //     });
              //     return os;
              // });

      } catch ( e ) {

          return  [];
      }
  }

  async getSymbolOperations(id, hideLoading = false) {

    try {

        const columns = this.store.selectSnapshot(state => state.carteraData).operacionColumnas;

        
        let resp = await  this.requestService.get('operacion_simbolo_index_id',{ hideLoading, params: { id: id } });

                AppHelper.FormatFromColumn(resp, columns, this.locale);
                resp.lotes = AppHelper.FormatNumber(resp.lotes, this.locale, 0, 'decimal');
                resp.operaciones.forEach(o => {

                    o.esCompra = o.esCompra ? 1 : 0;
                    o.inVolumen = o.volumen;
                    o.volumen = AppHelper.FormatNumber(o.volumen, this.locale, 0, 'decimal');
                    AppHelper.FormatFromColumn(o, columns, this.locale);
                });

        return resp;

    } catch ( e ) {

        return  [];
    }
}

  async agregarSimbolo(cartera: CarteraInterface, instrumento: InstrumentoInterface) {

    return await  this.requestService.post('operacion_simbolo_index',
      { hideLoading: false, params: {
          cartera: { id: cartera.id },
          simbolo: { id: instrumento.id }
        } });
  }

 importFile(formData){

    return this.requestService.postFile('operacion_simbolo_file', 
    {hideLoading: false,formData});
  }

 exportFile(idCartera, hideLoading = true) {
    return this.requestService.getFile('export_simbolo_file',
      { hideLoading,  params: {},query: `cartera=${idCartera}`});
  }

  async agregarSimboloOptions(cartera: CarteraInterface, activos: ActivosInterface) {

    return await  this.requestService.post('operacion_simbolo_options',
      { hideLoading: false, params: {
          cartera: { id: cartera.id },
          activos: activos
        } });
  }

  async guardarOperacion(op: OperacionInterface, opSimb?: number) {

    try {

      const params: any = { ...op, ...{
          precio: op.precio ? '' + op.precio : '',
          tipoOperacion: op.tipoOperacion ? { id: op.tipoOperacion } : null,
          nota: op?.nota || '',
          esCompra: op?.esCompra !== 0,
          volumen: op?.inVolumen === undefined ? 10 : op?.inVolumen
        }
      }

      if (!op.id) {

        params.broker = op.broker ? { id: op.broker }: null;
        params.simboloOperacion = { id: opSimb || op.simboloOperacion };

        return await this.requestService.post('operacion_index', { hideLoading: false, params });
      } else {

        return await this.requestService.put('operacion_details', { hideLoading: true, params });
      }
    } catch (e) {

      console.log(e);
      return false;
    }
  }

  async guardarOperacionEmail(op: OperacionInterface, opSimb?: number) {

    try {

      const params: any = { ...op, ...{
          precio: op.precio ? '' + op.precio : '',
          tipoOperacion: op.tipoOperacion ? { id: op.tipoOperacion } : null,
          nota: op?.nota || '',
          esCompra: op?.esCompra !== 0,
          volumen: op?.inVolumen === undefined ? 10 : op?.inVolumen
        }
      }

      if (!op.id) {

        params.broker = op.broker ? { id: op.broker }: null;
        params.simboloOperacion = { id: opSimb || op.simboloOperacion };

        return await this.requestService.post('operacion_index', { hideLoading: false, params });
      } else {

        return await this.requestService.put('operacion_details_emit', { hideLoading: true, params });
      }
    } catch (e) {

      console.log(e);
      return false;
    }
  }

  async guardarOptions(options: OptionsInterface, opSimb?: OperacionSimboloInterface) {

    try {

      const params: any = { ...options, ...{
          ticker: options.ticker 
        }
      }

      if (!options.id) {
        params.abrev = opSimb.simbolo.abrev;
        params.simboloOperacion = { id: opSimb.id || options.simboloOperacion };

        return await this.requestService.post('options_index', { hideLoading: false, params });
      } else {

        return await this.requestService.put('options_details', { hideLoading: true, params });
      }
    } catch (e) {

      console.log(e);
      return false;
    }
  }

  async actualizarTags(id: number, op: OperacionInterface, tags: string[]) {

    try {

        return await this.requestService.put('operacion_tags',
          {
            hideLoading: true,
            params: { id: op.id, cartera: id, tags: tags.map(t => t.toLowerCase()) } });
    } catch (e) {

      console.log(e);
      return false;
    }
  }

}
